// Shared status/discriminant constants for the Master Request Card feature
// (MC-B4/B8). Extracted from `===`/switch comparisons scattered across
// masterCardLabels.ts, MasterCardNotesPanel.tsx, MasterCardInspectionForm.tsx,
// and serviceRequests.ts (PR #3100 review N3) — one source of truth per
// discriminant instead of re-typed string literals at each call site.
//
// Const-object + derived-union-type idiom (not a TS `enum`): the values are
// plain strings read straight from Postgres/JSON columns, so this mirrors the
// codebase's existing convention for that shape (see PIPELINE_STAGES in
// src/lib/pipelineStages.ts) rather than introducing a TS enum's reverse
// mapping/nominal typing, which buys nothing here and doesn't match how the
// rest of the app models these columns.
//
// Importing `{ CardStatus }` (etc.) gives BOTH the runtime object
// (`CardStatus.New`) and the string-union type (`CardStatus`) from one name,
// same as importing a TS enum would.

export const CardStatus = {
  New: "new",
  Active: "active",
  Paused: "paused",
  Completed: "completed",
  Cancelled: "cancelled",
} as const;
export type CardStatus = (typeof CardStatus)[keyof typeof CardStatus];

export const NoteStatus = {
  PendingAdmin: "pending_admin",
  Converted: "converted",
  Dismissed: "dismissed",
} as const;
export type NoteStatus = (typeof NoteStatus)[keyof typeof NoteStatus];

/** MC-D1 inspection readiness choice — ready to market vs. needs work. */
export const Readiness = {
  Ready: "ready",
  NeedsWork: "needs_work",
} as const;
export type Readiness = (typeof Readiness)[keyof typeof Readiness];
